/* global angular, moment */
/**
 * Created by lari on 13/07/2017.
 */

(function () {
  'use strict';
  angular.module('vcclient')
    .component('clientsearch', {
      restrict: 'E',
      bindings: {
        parentsave: '&',
        mode: '@?',
        redirect: '@?',
        redirectnew: '@?',
        ti: '@?',
        grabfocus: '@?'
      },
      template: `
        <div class="form-group">
          <div class="input-group clientsearch">
            <!--<span class="input-group-btn" ng-show="vm.loadingNames || vm.noResults">-->
            <span class="input-group-btn">
              <button type="button" ng-show="vm.asyncSelected && vm.asyncSelected.length > 0"
                    ng-click="vm.addClient()"
                    ng-class="{'btn-success': vm.noResults, 'btn-warning': !vm.noResults}"
                    class="btn" tabindex="-1">
                <i class="fa fa-user-plus" uib-tooltip="Neuen {{vm.kunden}} anlegen" tooltip-placement="auto bottom"></i>
              </button>
              <button type="button" ng-hide="vm.asyncSelected"
                    ng-click="vm.addClient()"
                    ng-class="{'btn-warning': vm.noResults, 'btn-warning': !vm.noResults}"
                    class="btn" tabindex="-1">
                <i class="fa fa-user-plus" uib-tooltip="Neuen {{vm.kunden}} anlegen" tooltip-placement="auto bottom"></i>
              </button>
              <button type="button" ng-show="vm.loadingNames"
                    class="btn btn-info" tabindex="-1">
                <i ng-show="loadingNames" class="fa fa-spinner fa-spin"></i>
              </button>
              <button type="button" ng-show="vm.noResults"
                    class="btn btn-warning" tabindex="-1">
                <i ng-show="vm.noResults" class="fa fa-warning" uib-tooltip="Keine {{vm.kunden}} gefunden" tooltip-placement="auto bottom"></i>
              </button>

            </span>
              <input type="text" class="form-control" tabindex="{{vm.tabi}}"
                ng-class="{'dirtyfield': vm.asyncSelected.length > 0}"
                placeholder="{{vm.placeholder}}"
                ng-model="vm.asyncSelected"
                typeahead-on-select="$parent.$dismiss();vm.showclient($item, $model, $label)"
                uib-typeahead="client as client.text for client in vm.getClients($viewValue)"
                typeahead-loading="vm.loadingNames"
                typeahead-focus-first="false"
                typeahead-no-results="vm.noResults"
                typeahead-min-length=2 

                class="searchinput"
                >
              <span class="input-group-btn">
                <button type="submit"
                       ng-class="{'btn-warning': vm.noResults, 'btn-info': !vm.noResults}"
                       class="btn" tabindex="-1"><i class="fa fa-search"></i></button>
              </span>
          </div>
        </div>
        
<!--        <script type="text/ng-template" id="linebreaktpl.html">
          <ul class="dropdown-menu" ng-show="isOpen() && !moveInProgress" ng-style="{top: position().top+'px', left: position().left+'px'}" role="listbox" aria-hidden="{{!isOpen()}}">
              <li ng-repeat="match in matches track by $index" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" 
              style="max-width: 30em; background-color: red;"
                  ng-click="selectMatch($index, $event)" role="option" id="{{::match.id}}">
                  &nbsp;<div uib-typeahead-match index=$index" match="match" query="query" template-url="templateUrl"></div>
              </li>
          </ul>
        </script>
        
        
        <script type="text/ng-template" id="item.html">
            <span>I am an item<a href tabindex="-1" ng-bind-html="match.label | uibTypeaheadHighlight:query" ng-attr-title="{{match.label}}" style="max-width: 20em"></a></span>
        </script>-->
        
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Client', 'ClientHelper', '$state', 'Drug', '$element',
        function ($log, Client, ClientHelper, $state, Drug, $element) {
          let vm = this;
          // vm.save = save;
          vm.showclient = showclient;

          vm.getClients = getClients;
          vm.addClient = addClient;
          // vm.editClient = ClientHelper.editClient;

          vm.$onInit = function () {
            vm.newclient = {};


            // mode
            if (angular.isUndefined(vm.mode) || vm.mode !== 'patient') {
              vm.mode = 'client';
              vm.kunde = 'Kunde';
              vm.kunden = 'Kunden';
              vm.placeholder = 'Name, Firma, Stichwort';
            } else {
              vm.kunde = 'Patient';
              vm.kunden = 'Patienten';
              vm.placeholder = 'Name, Diagnose';
            }


            // taborder
            if (angular.isUndefined(vm.ti)) {
              vm.ti = 0;
              vm.tabi = 0;
            }
            if (angular.isString(vm.ti)) {
              vm.tabi = parseInt(vm.ti, 10);
            }
            else {
              vm.tabi = 0;
            }

          //  grabfocus
            if (angular.isDefined(vm.grabfocus) && vm.grabfocus !== false) {
              angular.element($element)[0].children[0].children[0].children[1].focus();
            }

          }; // $onInit

          function addClient() {
            $log.debug('debug - clientsearch addClient called');
            let client = {};
            client.primarycontact = {};
            client.primarycontact.lastname = vm.asyncSelected[0].toUpperCase() + vm.asyncSelected.slice(1);
            client.primarycontact.country = 'Österreich';
             if (vm.mode === 'patient') {
               client.dicompatid = moment().valueOf().toString() + Math.floor(Math.random() * 999).toString();
             }
            ClientHelper.create(client, vm.mode).$then(function (newclient) {
              delete vm.asyncSelected;
              delete vm.noResults;
              delete vm.loadingNames;
              $log.debug('handle newly create client: ', newclient);
              $log.debug('redirect new handle newly create client: ', vm.redirectnew, vm.mode);
              // If client is a patient, then create a patdrug record entry
              if (vm.mode === 'patient') {
                Drug.$create({patientid: newclient._id}).$then(function (patdrug) {
                    $log.info('freshly created patdrug entry for patient: ', vm.patientid, patdrug);
                  }, function (err) {
                  $log.error('failed to created patdrug entry for patient: ', vm.patientid);
                });
              }
              if (angular.isDefined(vm.redirectnew) && angular.isDefined(vm.mode)) {
                $state.go(vm.redirectnew, {client: newclient, clientid: newclient._id, mode: vm.mode});
              } else {
                $state.go('clientrecord.basicdata', {client: newclient, clientid: newclient._id, mode: 'client'});
              }
            }, function (err) {
              vm.error = true;
              $log.error(err);
            });
          }


          // typeahead client search backend query
          function getClients(val) {
            return ClientHelper.searchahead({
              query: val,
              fields: ['primarycontact.lastname', 'primarycontact.firstname', 'flatdiagnoses', 'companydata.name', 'svdata.svnr'],
              resultfields: ['primarycontact', 'flatdiagnoses', 'diagnoses', 'notes', 'risk', 'companydata.name', 'svdata.svnr', 'svdata.birthdate', 'svdata.bdateat']
            }, vm.mode).$asPromise().then(function (response) {
              return response.map(function (client) {
                ClientHelper.diagname(client, vm.mode, val);
                delete vm.error;
                return client;
              });
            });
          }

          // typeahead client search action
          function showclient($item, $model, $label, $event) {
            /* jshint unused:false */
            /* eslint "no-unused-lets": [2, {"args": "none"}] */
            // clear searchbox
            delete vm.asyncSelected;
            vm.client = $model;

            $log.debug('debug - vm.redirect: ', vm.redirect);


            if (angular.isDefined(vm.redirect) && angular.isString(vm.redirect) && vm.redirect.length > 0) {
              // TODO: $state.go requires valid state to transistion into
              $state.go(vm.redirect, {client: vm.client, clientid: vm.client._id, mode: vm.mode});
            } else {
              $log.debug('client in clientsearch; ', vm.client);
              vm.parentsave({client: vm.client, mode: vm.mode});
            }
          }
        }] // controller
    }); // component

// klammerfriedhof
}());
